var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{style:(_vm.styleChip()),attrs:{"x-small":"","dark":""}},[_vm._v(_vm._s(_vm.pedido.descstatus))])
}
var staticRenderFns = []

export { render, staticRenderFns }